import styled from 'styled-components';
import { Link } from '../link/Link';
export const BreadcrumbComponent = styled.h2 `
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: left;
`;
export const BackLink = styled(Link) `
  color: grey;
  padding: 10px;
  cursor: pointer;
`;
export const Item = styled(Link) `
  min-width: auto;
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  text-decoration: none;
  padding: 0px 30px 0px 0px;
  border: 0;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 14px;
    line-height: 20px;
    padding: 0px 40px 0px 0px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 0px;
  }

  &:hover {
    cursor: pointer;
  }
`;
export const ItemActive = styled.strong `
  text-decoration: none;
  min-width: auto;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grayScale100};
  line-height: 16px;
  font-weight: 600;
  padding: 0px;
  border: 0px;
  cursor: default;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 14px;
    line-height: 20px;
  }
`;
